module.exports = __webpack_public_path__ + "img/NBL1_South.88262516.jpeg";